import { DevicesService } from '@karnott/core-js';
import { API_BASE } from '../../constants';

export default new DevicesService({
  apiBase: API_BASE,
});
